/** Minimal typing for Fortis Commerce.js hosted fields (https://docs.fortis.tech). */
export interface CommerceElements {
  create(options: Record<string, unknown>): void;
  on(event: string, handler: (result: { data?: { id?: string } } & Record<string, unknown>) => void): void;
  off?(event: string, handler: (...args: unknown[]) => void): void;
}

declare global {
  interface Window {
    Commerce?: { elements: new (clientToken: string) => CommerceElements };
  }
}

const loads = new Map<string, Promise<void>>();

/** Loads the facility's Commerce.js script once (sandbox and production builds have different URLs). */
export function loadCommerceJs(url: string): Promise<void> {
  if (window.Commerce) return Promise.resolve();
  const existing = loads.get(url);
  if (existing) return existing;
  const p = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => (window.Commerce ? resolve() : reject(new Error("Commerce.js missing")));
    script.onerror = () => {
      loads.delete(url);
      script.remove();
      reject(new Error("Commerce.js failed to load"));
    };
    document.head.appendChild(script);
  });
  loads.set(url, p);
  return p;
}
